import { getAgentApi } from '@/gql';
import { Knowledge } from '@/gql/agent/__generated__/request';
import user from '@/stores/user';
import { useEffect, useState } from 'react';

export interface UseKnowledgesResult {
    knowledges: Knowledge[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<Knowledge[]>;
}

export const useKnowledges = (agentUid: string): UseKnowledgesResult => {
    const [knowledges, setKnowledges] = useState<Knowledge[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getKnowledges = async () => {
        if (!agentUid || !userId) {
            setKnowledges([]);
            return [];
        }
        try {
            setLoading(true);
            setError(null);
            const api = getAgentApi();
            const response = await api.knowledges({ agentUid });
            if (response?.knowledges !== undefined) {
                const reversedKnowledges = response.knowledges.reverse();
                setKnowledges(reversedKnowledges);
                return reversedKnowledges;
            } else {
                setKnowledges([]);
                return [];
            }
        } catch (err) {
            console.error('Failed to fetch knowledges:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch knowledges'),
            );
            setKnowledges([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getKnowledges();
    }, [agentUid, userId]);

    return {
        knowledges,
        loading,
        error,
        refetch: getKnowledges,
    };
};
